<template>
  <div
    class="theme-switch"
    :class="{ 'theme-switch--dark': isDark }"
    @click="toggle"
    role="switch"
    :aria-checked="isDark"
    tabindex="0"
    @keydown.space.enter="toggle"
  >
    <!-- Иконка солнца -->
    <a-icon
      icon="mdi:weather-sunny"
      class="theme-switch__icon theme-switch__icon--sun"
      :class="{ 'theme-switch__icon--active': !isDark }"
    />

    <!-- Иконка луны -->
    <a-icon
      icon="mdi:weather-night"
      class="theme-switch__icon theme-switch__icon--moon"
      :class="{ 'theme-switch__icon--active': isDark }"
    />

    <!-- Анимированный ползунок -->
    <div class="theme-switch__thumb"></div>
  </div>
</template>

<script>
export default {
  name: 'ThemeSwitch',
  data() {
    return {
      isDark: false
    }
  },
  methods: {
    toggle() {
      this.isDark = !this.isDark
      const theme = this.isDark ? 'theme-dark' : 'theme-light'

      // Безопасно обновляем классы body
      document.body.classList.remove('theme-light', 'theme-dark')
      document.body.classList.add(theme)

      localStorage.setItem('app-theme', theme)
      this.$emit('change', theme)
    }
  },
  mounted() {
    const saved = localStorage.getItem('app-theme') || 'theme-light'
    this.isDark = saved === 'theme-dark'

    document.body.classList.remove('theme-light', 'theme-dark')
    document.body.classList.add(saved)
  }
}
</script>

<style scoped>
.theme-switch {
  position: relative;
  width: 60px;
  height: 32px;
  background: #d4d4d8;
  border-radius: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  transition: background 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  user-select: none;
  outline: none;
}

.theme-switch--dark {
  background: #333;
}

/* Общие стили иконок */
.theme-switch__icon {
  position: absolute;
  font-size: 18px;
  opacity: 0;
  transform: scale(0.8);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
  pointer-events: none;
}

.theme-switch__icon--sun {
  right: 6px;
  color: #ffd54f;
}

.theme-switch__icon--moon {
  left: 6px;
  color: #9fa8da;
}

.theme-switch__icon--active {
  opacity: 1;
  transform: scale(1);
}

/* Ползунок */
.theme-switch__thumb {
  width: 24px;
  height: 24px;
  background: white;
  border-radius: 50%;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform 0.5s cubic-bezier(0.68, -0.6, 0.32, 1.6);
  z-index: 2;
}

.theme-switch--dark .theme-switch__thumb {
  transform: translateX(28px);
  background: #252525;
  box-shadow:
    0 2px 6px rgba(0, 0, 0, 0.4),
    0 1px 3px rgba(0, 0, 0, 0.3);
}
</style>
